<template lang="html">
  <!-- keep top level v-if in this component and not the parent because we need to keep sockets in scope -->
  <div>
    <!-- Modal with dynamic content inside -->
    <template v-if="!showPage && show_poll">
      <components
        v-if="!loading_poll"
        @selectPoll="selected_poll_id"
        @deletePoll="show_delete_poll = true"
        @closePollDialog="show_poll = false"
        @close="realTimeVote ? (show_poll = false) : $emit('close')"
        :selectedPoll="selected_poll"
        :is="poll_page"
        :realTimeVote="realTimeVote"
        class="show-poll"
      />
      <div class="flex middle-xs center-xs" style="height: 500px" v-else>
        <p class="pulsate">...loading poll</p>
      </div>
      <div>
        <dialog-delete-confirm
          v-if="show_delete_poll"
          @close="show_delete_poll = false"
          @actionConfirmed="deletePoll"
          optionalText="Delete Poll"
          :subHeader="'Are you sure you want to delete this poll? This action is irreversible!'"
        />
      </div>
    </template>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Create from './polls.create';
  import Vote from './polls.vote';
  import Results from './polls.results';
  import find from 'lodash/find';
  import findIndex from 'lodash/findIndex';
  import { EventBus } from 'utils/event-bus';
  import PlDialog from '../../components/material/components/plDialog/plDialog.vue';

  import dialogDeleteConfirm from 'components/dialogDeleteConfirm';

  export default {
    data() {
      return {
        loading_poll: false,
        selected_poll_id: '',
        show_poll: false,
        question: '',
        show_delete_poll: false,
      };
    },
    props: {
      showPage: {
        type: Boolean,
        default: false,
      },
      realTimeVote: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      Create,
      Vote,
      Results,
      PlDialog,
      dialogDeleteConfirm,
    },
    computed: {
      ...mapGetters([
        'getCurrentDiscussion',
        'hasTeacherPermissionsInCourse',
        'getProfile',
      ]),
      discussion_polls() {
        return this.getCurrentDiscussion.polls;
      },
      selected_poll() {
        return find(this.getCurrentDiscussion.polls, {
          id: this.selected_poll_id,
        });
      },
      poll_page() {
        const poll = this.selected_poll;
        const author = this.hasTeacherPermissionsInCourse;
        let page;
        if (poll && author) {
          page = poll.status === 'live' ? 'results' : 'create';
        } else {
          page = this.user_already_voted ? 'results' : 'vote';
        }
        return page;
      },
      user_already_voted() {
        return this.selected_poll
          ? findIndex(this.selected_poll.votes, {
              user_id: this.getProfile.id,
            }) !== -1
          : false;
      },
    },
    methods: {
      getAllPolls() {
        if (this.getCurrentDiscussion.id) {
          this.$store.dispatch('getAllPolls', this.getCurrentDiscussion.id);
        }
      },
      getPollVoters(poll) {
        return poll.votes.map((v) => v.user_id);
      },
      // TODO: make this actually work
      deletePoll() {
        // const confirmed = confirm(
        //   `Are you sure you want to delete this poll? This can't be undone.`
        // );
        //if (confirmed) {
        const pollID = this.selected_poll_id;
        this.$store.dispatch('deletePoll', pollID).then(() => {
          this.show_poll = false;
          this.selected_poll_id = '';
          const toast = {
            type: 'Error',
            message: 'Poll deleted!',
            time: 5000,
          };
          EventBus.$emit('createToast', toast);
        });
        //}
      },
      // Create a new poll - Teacher only
      createNewPoll() {
        this.$store
          .dispatch('createPoll', {
            answers: this.answers,
            status: 'draft',
            question: this.question,
            discussion_id: this.getCurrentDiscussion.id,
          })
          .then((poll) => {
            this.selected_poll_id = poll.id;
            this.show_poll = true;
          });
      },
    },
    mounted() {
      this.getAllPolls();
      this.unwatchCurrentDiscussionID = this.$watch(
        'getCurrentDiscussion.id',
        () => {
          this.getAllPolls();
        }
      );
      EventBus.$on('new_poll', (poll) => {
        this.show_poll = true;
        this.selected_poll_id = poll.id;
      });
      EventBus.$on('show_poll', (value) => {
        this.show_poll = value.show_poll;
        this.selected_poll_id = value.selected_poll_id;
      });
      EventBus.$on('close_poll', () => {
        if (!this.hasTeacherPermissionsInCourse) {
          EventBus.$emit('clear_vote');
        }
      });
    },
    beforeDestroy() {
      EventBus.$off('new_poll');
      EventBus.$off('show_poll');
      EventBus.$off('close_poll');
      this.unwatchCurrentDiscussionID();
    },
  };
</script>



// WEBPACK FOOTER //
// polls.modal.vue?55c04366